import { render } from "./BannerError.vue?vue&type=template&id=a431e370"
import script from "./BannerError.vue?vue&type=script&lang=js"
export * from "./BannerError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__